export function statusPaymentMap(status: string) {
    switch (status) {
        case 'PENDING': {
            return 'Chưa thanh toán'
        }
        case 'PAID': {
            return 'Đã thanh toán'
        }
        case 'RECEIVED': {
            return 'Đã tiếp nhận'
        }
        case 'REGISTERED': {
            return 'Đã đăng ký'
        }
        case 'MISSING_RECORDS': {
            return 'Thiếu hồ sơ'
        }
        case 'REGISTRATION_CANCELLED': {
            return 'Huỷ đăng ký'
        }
        case 'REFUNDED': {
            return 'Đã hoàn tiền'
        }
        default: {
            return 'Chưa thanh toán'
        }
    }

}

export const statusPaymentColorMap = {
    PENDING: 'badge badge-secondary',
    PAID: 'badge badge-success',
    MISSING_RECORDS: 'badge badge-warning',
    REFUNDED: 'badge badge-danger',
    RECEIVED: 'badge badge-secondary',
    REGISTERED: 'badge badge-secondary',
    REGISTRATION_CANCELLED: 'badge badge-danger',
}